import * as storage from './storage';

export function getPwId(): string | undefined {
	return storage.getFromCookie('authId') ?? undefined;
}

